import { createSelector } from 'reselect'

const getRetailers = (state) => state.retailers
const getStores = (state) => state.stores
const getOffers = (state) => state.offers
const getSelectedFilterCategory = (state) => state.selectedFilterCategory
const getTourismRetailers = (state) => state.tourismRetailers
const getRedeemModalOfferId = (state) => state.redeemModalOfferId
const getSuperCategories = (state) => state.superCategories

const getActiveRetailerSlug = (state, props) => props
const getActiveSuperCategorySlug = (state, props) => props

const processStores = createSelector(
    [getStores, getOffers],
    (stores, offers) => {
        return stores.map(store => {
            return {
                ...store,
                offers: offers.filter(offer => offer.store.uuid === store.id)
                    .filter(offer => offer.enabled)
                    .filter(offer => offer.validFrom ? new Date(offer.validFrom) <= Date.now() : offer)
                    .filter(offer => offer.validTo ? new Date(offer.validTo) >= Date.now() : offer)
            }
        })
            .filter(store => store.offers.length > 0)
    }
)

const buildOfferData = createSelector(
    [getRetailers, processStores],
    (retailers, processedStores) => {
        if (!retailers || !retailers.length) {
            return null
        }
        const offerData = retailers
            .map(retailer => {
                const stores = processedStores.filter(store => store.retailer.retailer === retailer.id)

                const categories = stores
                    .filter(store => store.category != null)
                    .reduce((accumulator, store) => {
                        return [
                            ...accumulator,
                            ...[].concat(...store.category.subCategories
                                .map(category => category.split('/')))
                        ]
                    }, []).filter((value, index, self) => self.indexOf(value) === index)


                return {
                    ...retailer,
                    categories: categories,
                    stores: stores
                }
            })
            .filter(retailer => retailer.stores.length > 0)

        return offerData
    }
)

const getActiveRetailer = createSelector(
    [getActiveRetailerSlug, buildOfferData],
    (activeRetailerSlug, offerData) => {
        return offerData.find(retailer => retailer.slug === activeRetailerSlug)
    }
)

const getActiveTourismRetailer = createSelector(
    [getActiveRetailerSlug, getTourismRetailers],
    (activeRetailer, tourismRetailers) => {
        return tourismRetailers.find(retailer => retailer.content.slug === activeRetailer)
    }
)

const getRedeemModalOffer = createSelector(
    [getRedeemModalOfferId, getOffers],
    (redeemModalOfferId, offers) => {
        return offers.find(offer => offer.id === redeemModalOfferId)
    }
)

const getActiveSuperCategory = createSelector(
    [getActiveSuperCategorySlug, getSuperCategories],
    (activeSuperCategorySlug, superCategories) => {
        return superCategories.find(cat => cat.slug === activeSuperCategorySlug)
    }
)

const getCurrentSubCategories = createSelector(
    [getActiveSuperCategory],
    (activeSuperCategory) => {
        return activeSuperCategory.subCategory
            .filter((value, index, self) => self.findIndex(x => x.slug === value.slug) === index)
            .sort((a, b) => a.displayOrder - b.displayOrder)

    }
)

const getFilterCategory = createSelector(
    [getSelectedFilterCategory, getActiveSuperCategory],
    (selectedFilterCategory, activeSuperCategory) => {
        return selectedFilterCategory ?
            activeSuperCategory.subCategory
                .find(cat => cat.slug === selectedFilterCategory.slug) :
            null
    }
)

const getVisibleOffers = createSelector(
    [buildOfferData, getActiveSuperCategorySlug, getFilterCategory],
    (offerData, activeSuperCategorySlug, selectedFilterCategory) => {
        if (!offerData || !offerData.length) {
            return null
        }
        return offerData.filter(retailer => {
            return retailer.categories.indexOf(activeSuperCategorySlug) !== -1
                && (
                    selectedFilterCategory == null ||
                    retailer.categories.indexOf(selectedFilterCategory.slug) !== -1
                )
        })
    }
)

const getCurrentSubCategoriesWithOffers = createSelector(
    [getCurrentSubCategories, buildOfferData],
    (subCategories, offerData) => {
        let subCategoriesWithOffers = [].concat.apply([], offerData.map(retailer => retailer.categories)).filter((value, index, self) => self.indexOf(value) === index)
        return subCategories.filter(category => subCategoriesWithOffers.includes(category.slug))
    }
)

const groupRetailers = createSelector(
    [getVisibleOffers],
    (retailers) => {
        if (!retailers || !retailers.length) {
            return null
        }
        const filteredStores = retailers.reduce((accumulator, retailer) => {
            const char = retailer.name[0].toUpperCase()
            const firstChar = /[A-Z]/.test(char) ? char : '#';

            if (accumulator[firstChar] == null) {
                accumulator[firstChar] = []
            }

            accumulator[firstChar].push(retailer)
            return accumulator
        }, {})

        return Object.keys(filteredStores).sort().map((sectionLetter) => {
            return {
                letter: sectionLetter,
                stores: filteredStores[sectionLetter].sort((a, b) => {
                    return b.name < a.name
                })
            }
        })
    }
)

export {
    buildOfferData,
    getActiveRetailer,
    getVisibleOffers,
    getActiveTourismRetailer,
    getRedeemModalOffer,
    getActiveSuperCategory,
    getCurrentSubCategories,
    getFilterCategory,
    groupRetailers,
    getCurrentSubCategoriesWithOffers
}


// WEBPACK FOOTER //
// ./selectors.js